import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledEmployerDirectory,
  StyledEmployerName,
  StyledEmployerLastName,
  StyledPhoto,
  StyledEmployerTableCellProfile,
  StyledEmployerTableCellDepartment,
  StyledWrapperPhoto,
  IconButton
} from './style';

import { Arrow } from '../../../../assets/images/index';
import { AVATAR_MEDIUM } from '../../../utils/crops';

class RowDirectory extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.state = { active: false };
  }

  onClick() {
    const { active } = this.state;
    const {
      row,
      dataRow,
      rowSelected,
      setRowSelected,
      setEmployeeSelected
    } = this.props;
    this.setState({ active: !active });

    if (row !== rowSelected) {
      setRowSelected(row);
      setEmployeeSelected({
        text: `${dataRow.name} ${dataRow.lastname}`,
        value: dataRow.userId
      });
    }
  }

  render() {
    const { dataRow, row, rowSelected } = this.props;
    const { active } = this.state;

    return (
      <StyledEmployerDirectory
        active={active}
        row={row}
        rowSelected={rowSelected}
        onClick={this.onClick}
      >
        <IconButton
          svg={Arrow}
          size="s"
          hover
          active={active}
          onClick={this.onClick}
        />
        <StyledWrapperPhoto>
          <StyledPhoto
            name={dataRow.name}
            lastname={dataRow.lastname}
            userId={String(dataRow.userId)}
            crop={AVATAR_MEDIUM}
            avatarPhoto={dataRow.avatarPhoto && dataRow.avatarPhoto}
            directory
          />
        </StyledWrapperPhoto>
        <StyledEmployerName title={dataRow.name}>
          {' '}
          {dataRow.name}{' '}
        </StyledEmployerName>
        <StyledEmployerLastName title={dataRow.lastname}>
          {' '}
          {dataRow.lastname}{' '}
        </StyledEmployerLastName>
        <StyledEmployerTableCellProfile title={dataRow.profile}>
          {' '}
          {dataRow.profile}{' '}
        </StyledEmployerTableCellProfile>
        <StyledEmployerTableCellDepartment title={dataRow.department}>
          {dataRow.department}
        </StyledEmployerTableCellDepartment>
      </StyledEmployerDirectory>
    );
  }
}

RowDirectory.propTypes = {
  dataRow: PropTypes.shape({
    userId: PropTypes.number,
    name: PropTypes.string,
    lastname: PropTypes.string,
    profile: PropTypes.string,
    department: PropTypes.string,
    extension: PropTypes.number,
    phones: PropTypes.string,
    email: PropTypes.string
  })
};

export default RowDirectory;
